import dispatcher from '../dispatcher';
import sliderStore from '../slider/slider.store';

var elementProto = Object.create(HTMLElement.prototype);

function translate(element, options) {
	var dist = options.distance || 0;
	var opacity = options.opacity || 0;
	var ease = options.ease || 'ease';
	var delay = options.delay || 0;
	var duration = options.duration || 0;

	if (!element) return;
	element.style.transitionProperty = 'opacity, transform';

	element.style.transitionDuration = duration + 's';
	element.style.transitionDelay = delay + 's';

	element.style.transitionTimingFunction = 'ease, ' + ease;

	element.style.opacity = opacity;
	element.style.transform = 'translateX(' + dist + 'px) translateZ(0)';
}

var _detectWay = function(next) {
	var way;
	if (next < this._index) {
		if (this._notContinuous) {
			way = 'prev';
		} else {
			if ((this._index - next) <= (this._total - (this._index - next))) {
				way = 'prev';
			} else {
				way = 'next';
			}
		}
	} else {
		if (this._notContinuous) {
			way = 'next';
		} else {
			if ((next - this._index) <= (this._total - (next - this._index))) {
				way = 'next';
			} else {
				way = 'prev';
			}
		}
	}
	return way;
}

var _handleSliderStore = function() {
	var sliderData = sliderStore.getData()[this._id];
	var way;
	var distance;
	var self = this;

	if (!sliderData) return;

	if (sliderData.index === this._index) return;

	way = this.detectWay(sliderData.index);
	distance = way === 'prev' ? 200 : -200;

	translate(this._slides[this._index].i1, {
		distance: distance,
		ease: 'ease-in',
		duration: 0.4
	});
	translate(this._slides[this._index].i2, {
		distance: distance,
		ease: 'ease-in',
		delay: 0.15,
		duration: 0.4
	});

	this._index = sliderData.index;

	translate(this._slides[this._index].i1, {
		distance: -distance / 2,
	});
	translate(this._slides[this._index].i2, {
		distance: -distance / 2,
	});

	setTimeout(function() {
		translate(self._slides[self._index].i1, {
			ease: 'ease-out',
			opacity: 0.2,
			delay: 0.1,
			duration: 0.45
		});
		translate(self._slides[self._index].i2, {
			ease: 'ease-out',
			delay: 0.3,
			opacity: 1,
			duration: 0.45
		});
	}, 20);
}

elementProto.createdCallback = function() {
	this.handleSliderStore = _handleSliderStore.bind(this);
	this.detectWay = _detectWay.bind(this);
}
elementProto.attachedCallback = function() {
	var self = this;

	this._id = this.getAttribute('data-id');
	this._index = 0;

	this._slideElements = this.getElementsByClassName('slide');
	this._slideElements = Array.prototype.slice.call(this._slideElements);
	this._slides = [];

	this._total = this._slideElements.length;

	this._slideElements.forEach(function(slide, index) {
		var i1 = slide.getElementsByClassName('i1')[0];
		var i2 = slide.getElementsByClassName('i2')[0];

		self._slides.push({
			i1: i1,
			i2: i2
		});

		if (index !== 0) {
			i1.style.opacity = 0;
			i2.style.opacity = 0;
		}
	});

	this.classList.add('initialized');

	this.handleSliderStore();
	sliderStore.subscribe(this.handleSliderStore);
}
elementProto.detachedCallback = function() {
	sliderStore.unsubscribe(this.handleSliderStore);
}

document.registerElement('ico-slider', {
	prototype: elementProto
});